import React from 'react';
import T from 'prop-types';
import moment from 'moment';
import {
  CardSubtitle,
  CardTitle,
  CashbackCard,
  ChartBar,
  ChartBarColumn,
  ChartBarLabel,
  ChartBarValue,
  ChartWrap
} from 'routes/App/cashback/styles';

const formatPercent = (value) => {
  if (value == null) return '0%';
  const rounded = Math.round(value * 10) / 10;
  return `${rounded}%`;
};

const ParticipationChart = ({weeklyParticipation}) => {
  const bars =
    weeklyParticipation && weeklyParticipation.length
      ? weeklyParticipation
      : Array.from({length: 5}, () => ({weekStart: null, percent: 0}));

  return (
    <CashbackCard>
      <CardTitle>Cashback participation</CardTitle>
      <CardSubtitle>
        Weekly share of orders with Cashback activity over the last 5 weeks.
      </CardSubtitle>
      <ChartWrap>
        {bars.map((bar, idx) => (
          <ChartBarColumn key={bar.weekStart || `bar-${idx}`}>
            <ChartBarValue>{formatPercent(bar.percent)}</ChartBarValue>
            <ChartBar fillPercent={Math.min(bar.percent || 0, 100)} />
            <ChartBarLabel>
              {bar.weekStart ? moment(bar.weekStart).format('MMM D') : '—'}
            </ChartBarLabel>
          </ChartBarColumn>
        ))}
      </ChartWrap>
    </CashbackCard>
  );
};

ParticipationChart.propTypes = {
  weeklyParticipation: T.arrayOf(
    T.shape({
      weekStart: T.string,
      percent: T.number
    })
  )
};

ParticipationChart.defaultProps = {
  weeklyParticipation: []
};

export default ParticipationChart;
